import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import CurrentUserContext from "../contexts/CurrentUserContext";
import { getLoginRedirectPath } from "../utils/redirect";
import { customerNeedsLicenseAgreement } from "../utils/licenseAccess";

const LICENSE_AGREEMENT_ROUTE = "/license-agreement";

const PrivateRoute = ({
  children,
  isPublic = false,
  requiredAccessType,
  requiredUserType,
}) => {
  const { currentUser } = useContext(CurrentUserContext);
  const location = useLocation();
  const redirectPath = getLoginRedirectPath(location.state?.from);
  if (isPublic && currentUser !== null) {
    return <Navigate to={redirectPath} replace />;
  }

  if (!isPublic && currentUser === null) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requiredUserType && currentUser?.userType !== requiredUserType) {
    return <Navigate to={redirectPath} replace />;
  }

  const needsLicenseAgreement = customerNeedsLicenseAgreement(currentUser);

  if (needsLicenseAgreement) {
    if (location.pathname !== LICENSE_AGREEMENT_ROUTE) {
      return (
        <Navigate
          to={LICENSE_AGREEMENT_ROUTE}
          replace
          state={{ from: location }}
        />
      );
    }
    return children;
  }

  const blockedRedirectPath = currentUser?.licenseStatus?.redirectPath;
  const isBlockedCustomer = currentUser?.licenseStatus?.isBlocked;
  const isAllowedBlockedRoute = location.pathname === blockedRedirectPath;

  if (isBlockedCustomer && blockedRedirectPath && !isAllowedBlockedRoute) {
    return <Navigate to={blockedRedirectPath} replace />;
  }

  if (requiredAccessType && currentUser?.userAccessType !== requiredAccessType) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default PrivateRoute;
